import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import { Helmet } from 'react-helmet-async';
import { Divider, styled, Tab, Tabs, Typography } from '@mui/material';
import UsersListSvg from 'src/assets/svgs/usersList';
import SmsPlanAssign from './smsPlanAssign';
import {  useLocation, useNavigate } from 'react-router-dom';
import SmsCutting from './smsCutting';
import { checkButtonAccess } from 'src/utils/common';
import SmsCampaignSetting from './smsCampaignSetting';

const MainSection = styled('div')(() => ({
    padding: '64px 20px 0px 88px',
    backgroundColor: 'rgb(240, 240, 240)',
    height: '100vh',
    overflow: 'hidden'
}));

const HeadingSection = styled('div')(() => ({
    width: '100%',
    padding: '20px 0',
    display: 'flex',
    justifyContent: 'space-between',
}));

const HeadingContentSection = styled('div')(() => ({
    display: 'flex',
    gap: '15px',
    alignItems: 'center',
}));

function CustomTabPanel({ children, value, index }) {
    return (
        <Box
            role="tabpanel"
            hidden={value !== index}
            sx={{ flexGrow: 1, height: '100%', overflow: 'auto' }}
        >
            {value === index && <Box sx={{ p: 2 }}>{children}</Box>}
        </Box>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    value: PropTypes.string.isRequired,
    index: PropTypes.string.isRequired,
};

const TAB_VALUES = {
    PLANS: 'plans',
    CUTTING: 'cutting',
    CAMPAIGN_SETTING: 'campaignSetting',
};

const SmsActions = () => {

    const navigate = useNavigate();

    const [value, setValue] = useState(TAB_VALUES.PLANS);

    const { state } = useLocation();
    const user = state?.user;
    
    const hasCuttingAccess = checkButtonAccess("smsUserSetting", "w");
    const hasCommonAccess = checkButtonAccess("smsCommonSetting", "w");

    useEffect(() => {
  if (!user?.userId || !user?.email) {
    navigate('/console_users');
  }
}, [user]);


    return (
        <>
            <Helmet>
                <title>SMS Plan Assign to user</title>
            </Helmet>

            <MainSection>
                {/* <HeadingSection>
                    <HeadingContentSection> */}
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '15px 0',
                    }}
                >
                    {/* Left side: Icon + Title */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                        <UsersListSvg />
                        <Typography variant="h5" fontWeight={600}>
                            SMS Actions
                        </Typography>
                    </Box>

                    {/* Right side: User Info */}
                    <Box sx={{ textAlign: 'right' }}>
                        <Typography variant="subtitle2" color="text.secondary">
                            User ID: {user?.userId}
                        </Typography>
                        <Typography variant="subtitle2" color="text.secondary">
                            Email: {user?.email}
                        </Typography>
                    </Box>
                </Box>

                {/* </HeadingContentSection>
                </HeadingSection> */}

                <Divider />

                <Box
                    sx={{
                        display: 'flex',
                        height: 'calc(100vh - 160px)',
                        bgcolor: 'background.paper',
                        overflow: 'hidden'
                    }}
                >
                    <Tabs
                        orientation="vertical"
                        value={value}
                        onChange={(e, v) => setValue(v)}
                        sx={{
                            borderRight: 1,
                            borderColor: 'divider',
                            width: '150px',
                            minWidth: '150px',
                            '& .MuiTab-root': {
                                justifyContent: 'flex-start',
                                paddingLeft: '12px',
                            },
                        }}
                    >
                        <Tab value={TAB_VALUES.PLANS} label="Plans" />
                        <Divider />
                        {hasCuttingAccess && <Tab value={TAB_VALUES.CUTTING} label="Cutting" />}
                        {hasCuttingAccess && <Divider />}
                        {hasCommonAccess && (
                            <Tab value={TAB_VALUES.CAMPAIGN_SETTING} label="Campaign Setting" />
                        )}
                        {hasCommonAccess && <Divider />}
                    </Tabs>

                    <CustomTabPanel value={value} index={TAB_VALUES.PLANS}>
                        <SmsPlanAssign user={user} />
                    </CustomTabPanel>

                    {hasCuttingAccess && (
                        <CustomTabPanel value={value} index={TAB_VALUES.CUTTING}>
                            <SmsCutting user={user} />
                        </CustomTabPanel>
                    )}
                    {hasCommonAccess && (
                        <CustomTabPanel value={value} index={TAB_VALUES.CAMPAIGN_SETTING}>
                            <SmsCampaignSetting user={user} />
                        </CustomTabPanel>
                    )}
                </Box>
            </MainSection>
        </>
    );
};

export default SmsActions;
